[
    {
      "id": "E1-ccm",
      "title": "Climate change mitigation",
      "description": "(ESRS sub-topic) refers to the reduction of GHG emissions to limit global warming, aligning with the Paris Agreement's goal to keep the temperature increase to 1.5 °C above pre-industrial levels."
    },
    {
      "id": "E1-cca",
      "title": "Climate change adaptation",
      "description": "(ESRS sub-topic) refers to the adjustment to actual or expected climate change and its impacts."
    },
    {
      "id": "E1-nrj",
      "title": "Energy",
      "description": "(ESRS sub-topic) refers to the management of energy production and consumption, transition to renewables, as well as performance and policies on energy efficiency."
    },
    {
      "id": "E2-mpl",
      "title": "Microplastics",
      "description": "(ESRS sub-topic) refers to the release of plastic particles (less than 5mm) into the environment."
    },
    {
      "id": "E2-poa",
      "title": "Pollution of air",
      "description": "(ESRS sub-topic) refers to the direct or indirect emission of pollutants into air that may harm human health, ecosystems, or property."
    },
    {
      "id": "E2-pws",
      "title": "Pollution of water and soil",
      "description": "(ESRS sub-topic) refers to the direct or indirect emission of pollutants into water or soil that may harm human health, ecosystems, or property."
    },
    {
      "id": "E2-soc",
      "title": "Substances of concern",
      "description": "(ESRS sub-topic) refers to the production, use, or handling of chemicals harmful to health or the environment under EU regulations."
    },
    {
      "id": "E2-sohc",
      "title": "Substances of very high concern",
      "description": "(ESRS sub-topic) refers to the production, use, and handling of chemicals with severe hazards (SVHCs) identified under EU REACH regulation."
    },
    {
      "id": "E3-emr",
      "title": "Extraction and use of marine resources",
      "description": "(ESRS sub-sub-topic) refers to the extraction and use of biological (e.g. seafood) and non-biological (e.g. deep-sea minerals) materials found in the seas and oceans."
    },
    {
      "id": "E3-wdi",
      "title": "Water discharges",
      "description": "(ESRS sub-sub-topic) refers to the water and effluents discharged to surface water, groundwater, or third-party treatment facilities."
    },
    {
      "id": "E3-wwc",
      "title": "Water withdrawals and consumption",
      "description": "(ESRS sub-sub-topic) refers to all kinds of water withdrawal (total water taken from a source) and water consumption (the portion of that water not returned)."
    },
    {
      "id": "E4-aes",
      "title": "Invasive alien species",
      "description": "(ESRS sub-sub-topic) refers to the non-native organisms introduced by human activity that may harm biodiversity, food security, and human well-being."
    },
    {
      "id": "E4-bcc",
      "title": "Climate change",
      "description": "driving biodiversity loss (ESRS sub-sub-topic) refers to the biodiversity impacts of climate change."
    },
    {
      "id": "E4-dex",
      "title": "Direct exploitation",
      "description": "of ecosystems and species (ESRS sub-sub-topic) refers to the direct utilization and harvesting of wild species through activities like fishing, logging, and hunting."
    },
    {
      "id": "E4-ecos",
      "title": "Ecosystems and species",
      "description": "(ESRS sub-topic) refers to the impacts on species populations and ecosystem health, integrity, and extent."
    },
    {
      "id": "E4-ess",
      "title": "Ecosystem services",
      "description": "contributing to human activity (ESRS sub-topic) refers to the benefits humans obtain from nature, such as clean water or crop pollination."
    },
    {
      "id": "E4-luc",
      "title": "Land-use change, fresh water-use change and sea-use change",
      "description": "affecting biodiversity (ESRS sub-sub-topic) refers to the human-driven changes to land, water, or sea areas affecting biodiversity."
    },
    {
      "id": "E4-pol",
      "title": "Pollution",
      "description": "driving biodiversity loss (ESRS sub-sub-topic) refers to the biodiversity impacts from pollutants entering air, water, or soil due to human activity."
    },
    {
      "id": "E5-rin",
      "title": "Resource inflows, including resource use",
      "description": "(ESRS sub-topic) refers to the materials entering company facilities or upstream value chain for products or services."
    },
    {
      "id": "E5-row",
      "title": "Resource outflows and waste",
      "description": "(ESRS sub-topic) refers to the materials flowing out of a company and its value chain, from finished products to waste generated during production and after consumer use."
    },
    {
      "id": "G1-anw",
      "title": "Animal welfare",
      "description": "(ESRS sub-topic) refers to the physical and mental state of animals relative to living and dying conditions."
    },
    {
      "id": "G1-ccu",
      "title": "Corporate culture",
      "description": "(ESRS sub-topic) refers to the shared values, beliefs, and norms that guide a company's activities."
    },
    {
      "id": "G1-cob",
      "title": "Corruption and bribery",
      "description": "(ESRS sub-topic) refers to the abuse of entrusted power for private gain, including bribery, fraud, extortion, or money laundering."
    },
    {
      "id": "G1-poe",
      "title": "Political engagement",
      "description": "(ESRS sub-topic) refers to the efforts to influence policy through activities like lobbying and political contributions."
    },
    {
      "id": "G1-rws",
      "title": "Management of relationships with suppliers including payment practices",
      "description": "(ESRS sub-topic) refers to maintaining fair contracts and responsible payment practices, especially for smaller suppliers."
    },
    {
      "id": "G1-wbl",
      "title": "Protection of whistle-blowers",
      "description": "(ESRS sub-topic) refers to protecting the rights of individuals reporting harassment, abuse, corruption, or other wrongdoings."
    },
    {
      "id": "S1-adh",
      "title": "Adequate housing",
      "description": "for own workforce (ESRS sub-sub-topic) refers to providing workers with safe, healthy, and affordable housing when their job requires them to live in a specific location, such as a remote work site."
    },
    {
      "id": "S1-cbg",
      "title": "Collective bargaining, including rate of workers covered by collective agreements",
      "description": "for own workforce (ESRS sub-sub-topic) refers to the negotiations between management and worker representatives on employment terms."
    },
    {
      "id": "S1-chl",
      "title": "Child labour",
      "description": "in own workforce (ESRS sub-sub-topic) refers to the work that is done by persons below the legal minimum age or any work that is harmful to a child's health, safety, and development."
    },
    {
      "id": "S1-div",
      "title": "Diversity",
      "description": "in own workforce (ESRS sub-sub-topic) refers to the mix of employee backgrounds and inclusion practices ensuring all feel valued."
    },
    {
      "id": "S1-dlg",
      "title": "Social dialogue",
      "description": "with own workforce (ESRS sub-sub-topic) refers to the communication between management and workers on topics of mutual interest."
    },
    {
      "id": "S1-emp",
      "title": "Secure employment",
      "description": "for own workforce (ESRS sub-sub-topic) refers to providing stable employment via permanent contracts and predictable conditions."
    },
    {
      "id": "S1-foa",
      "title": "Freedom of association, the existence of works councils and the information, consultation and participation rights of workers",
      "description": "for own workforce (ESRS sub-sub-topic) refers to the right to form or join organizations and unions without employer interference."
    },
    {
      "id": "S1-fol",
      "title": "Forced labour",
      "description": "in own workforce (ESRS sub-sub-topic) refers to the work performed involuntarily under threat of penalty, including debt bondage and modern slavery."
    },
    {
      "id": "S1-geq",
      "title": "Gender equality and equal pay for work of equal value",
      "description": "in own workforce (ESRS sub-sub-topic) refers to equal opportunities, pay, and representation across genders, and fair representation across all levels of the organization."
    },
    {
      "id": "S1-has",
      "title": "Health and safety",
      "description": "of own workforce (ESRS sub-sub-topic) refers to the policies and systems preventing work-related injuries or illnesses, ensuring the physical and mental well-being of the workforce."
    },
    {
      "id": "S1-ipd",
      "title": "Employment and inclusion of persons with disabilities",
      "description": "of people with disabilities in own workforce (ESRS sub-sub-topic) refers to including people with disabilities in the workforce by removing barriers and providing accommodations."
    },
    {
      "id": "S1-mvh",
      "title": "Measures against violence and harassment in the workplace",
      "description": "(ESRS sub-sub-topic) refers to preventing and addressing workplace violence and harassment."
    },
    {
      "id": "S1-prv",
      "title": "Privacy",
      "description": "of own workforce (ESRS sub-sub-topic) refers to the ethical handling of employee data and protection of their personal space, ensuring any workplace monitoring is justified and transparent."
    },
    {
      "id": "S1-tas",
      "title": "Training and skills development",
      "description": "of own workforce (ESRS sub-sub-topic) refers to the possibilities to maintain and upgrade employee competencies."
    },
    {
      "id": "S1-wag",
      "title": "Adequate wages",
      "description": "for own workforce (ESRS sub-sub-topic) refers to the payment of a living wage covering basic needs, potentially above legal minimum."
    },
    {
      "id": "S1-was",
      "title": "Water and sanitation",
      "description": "for own workforce (ESRS sub-sub-topic) refers to the access to safe, clean water and sanitation facilities."
    },
    {
      "id": "S1-wlb",
      "title": "Work-life balance",
      "description": "of own workforce (ESRS sub-sub-topic) refers to the policies enabling balance between work and personal life, like flexible work arrangements and family leave."
    },
    {
      "id": "S1-wtm",
      "title": "Working time",
      "description": "of own workforce (ESRS sub-sub-topic) refers to the policies governing hours, overtime, and rest periods, ensuring they are fair, legally compliant, and support employee well-being. "
    },
    {
      "id": "S2-adh",
      "title": "Adequate housing",
      "description": "for value chain workers (ESRS sub-sub-topic) refers to providing workers with safe, healthy, and affordable housing when their job requires them to live in a specific location (such as a remote work site) across value chains."
    },
    {
      "id": "S2-cbg",
      "title": "Collective bargaining, including rate of workers covered by collective agreements",
      "description": "for value chain workers (ESRS sub-sub-topic) refers to the negotiations between management and worker representatives on employment terms across value chains."
    },
    {
      "id": "S2-chl",
      "title": "Child labour",
      "description": "in the value chain (ESRS sub-sub-topic) refers to the work that is done by persons below the legal minimum age or any work that is harmful to a child's health, safety, and development across value chains."
    },
    {
      "id": "S2-div",
      "title": "Diversity",
      "description": "in the value chain (ESRS sub-sub-topic) refers to the mix of employee backgrounds and inclusion practices ensuring all feel valued across value chains."
    },
    {
      "id": "S2-dlg",
      "title": "Social dialogue",
      "description": "with value chain workers (ESRS sub-sub-topic) refers to the communication between management and workers on topics of mutual interest across value chains."
    },
    {
      "id": "S2-emp",
      "title": "Secure employment",
      "description": "for value chain workers (ESRS sub-sub-topic) refers to providing stable employment via permanent contracts and predictable conditions across value chains."
    },
    {
      "id": "S2-foa",
      "title": "Freedom of association, the existence of works councils and the information, consultation and participation rights of workers",
      "description": "for value chain workers (ESRS sub-sub-topic) refers to the right to form or join organizations and unions without employer interference across value chains."
    },
    {
      "id": "S2-fol",
      "title": "Forced labour",
      "description": "in the value chain (ESRS sub-sub-topic) refers to the work performed involuntarily under threat of penalty, including debt bondage and modern slavery across value chains."
    },
    {
      "id": "S2-geq",
      "title": "Gender equality and equal pay for work of equal value",
      "description": "in value chain (ESRS sub-sub-topic) refers to equal opportunities, pay, and representation across genders, and fair representation across all levels of the organization across value chains."
    },
    {
      "id": "S2-has",
      "title": "Health and safety",
      "description": "of value chain workers (ESRS sub-sub-topic) refers to the policies and systems preventing work-related injuries or illnesses,  ensuring the physical and mental well-being of the workforce across value chains."
    },
    {
      "id": "S2-ipd",
      "title": "Employment and inclusion of persons with disabilities",
      "description": "in the value chain (ESRS sub-sub-topic) refers to including people with disabilities in the workforce by removing barriers and providing accommodations across value chains."
    },
    {
      "id": "S2-mvh",
      "title": "Measures against violence and harassment",
      "description": "in the value chain (ESRS sub-sub-topic) refers to preventing and addressing workplace violence and harassment across value chains."
    },
    {
      "id": "S2-prv",
      "title": "Privacy",
      "description": "of value chain workers (ESRS sub-sub-topic) refers to the ethical handling of employee data and protection of their personal space, ensuring any workplace monitoring is justified and transparent across value chains."
    },
    {
      "id": "S2-tas",
      "title": "Training and skills development",
      "description": "for value chain workers (ESRS sub-sub-topic) refers to the possibilities to maintain and upgrade employee competencies across value chains."
    },
    {
      "id": "S2-wag",
      "title": "Adequate wages",
      "description": "for value chain workers (ESRS sub-sub-topic) refers to the payment of a living wage covering basic needs, potentially above legal minimum across value chains."
    },
    {
      "id": "S2-was",
      "title": "Water and sanitation",
      "description": "for value chain workers (ESRS sub-sub-topic) refers to the access to safe, clean water and sanitation facilities across value chains."
    },
    {
      "id": "S2-wlb",
      "title": "Work-life balance",
      "description": "of value chain workers (ESRS sub-sub-topic) refers to the policies enabling balance between work and personal life, like flexible work arrangements and family leave across value chains."
    },
    {
      "id": "S2-wtm",
      "title": "Working time",
      "description": "of value chain workers (ESRS sub-sub-topic) refers to the policies governing hours, overtime, and rest periods, ensuring they are fair, legally compliant, and support employee well-being across value chains. "
    },
    {
      "id": "S3-afo",
      "title": "Adequate food",
      "description": "for affected communities (ESRS sub-sub-topic) refers to ensuring access to nutritious food for local individuals or groups potentially impacted by a company’s activities."
    },
    {
      "id": "S3-ahs",
      "title": "Adequate housing",
      "description": "for affected communities (ESRS sub-sub-topic) refers to ensuring access to safe and affordable housing for local individuals or groups potentially impacted by a company’s activities"
    },
    {
      "id": "S3-cst",
      "title": "Free, prior and informed consent",
      "description": "for indigenous peoples on decisions affecting them (ESRS sub-sub-topic) refers to the right to approve or withhold consent for projects affecting their lands or culture."
    },
    {
      "id": "S3-cur",
      "title": "Cultural rights",
      "description": "of indigenous peoples (ESRS sub-sub-topic) refers to the rights to maintain heritage sites, livelihoods, or languages."
    },
    {
      "id": "S3-foa",
      "title": "Freedom of assembly",
      "description": "for affected communities (ESRS sub-sub-topic) refers to the right to gather peacefully for protests or meetings."
    },
    {
      "id": "S3-foe",
      "title": "Freedom of expression",
      "description": "for affected communities (ESRS sub-sub-topic) refers to the right to voice concerns without fear of reprisal."
    },
    {
      "id": "S3-has",
      "title": "Health and safety",
      "description": "of affected communities (ESRS sub-sub-topic) refers to the safe and healthy environment for local individuals or groups potentially impacted by a company’s activities."
    },
    {
      "id": "S3-hrd",
      "title": "Impacts on human rights defenders",
      "description": "(ESRS sub-sub-topic) refers to protecting them from harm due to raising concerns."
    },
    {
      "id": "S3-lri",
      "title": "Land-related impacts",
      "description": "impacts on affected communities (ESRS sub-sub-topic) refers to respecting land rights and fair land acquisition processes."
    },
    {
      "id": "S3-sdt",
      "title": "Self-determination",
      "description": "of indigenous peoples (ESRS sub-sub-topic) refers to the right to govern economic, social, and cultural future."
    },
    {
      "id": "S3-sri",
      "title": "Security-related impacts",
      "description": "on affected communities (ESRS sub-sub-topic) refers to ensuring company activities do not compromise physical or psychological safety."
    },
    {
      "id": "S3-was",
      "title": "Water and sanitation",
      "description": "for affected communities (ESRS sub-sub-topic) refers to ensuring access to safe water, sanitation, and hygiene for local individuals or groups potentially impacted by a company’s activities."
    },
    {
      "id": "S4-aps",
      "title": "Access to products and services",
      "description": "(ESRS sub-sub-topic) refers to the fair and non-discriminatory access to essential products and services for end-users, especially vulnerable groups."
    },
    {
      "id": "S4-aqi",
      "title": "Access to (quality) information",
      "description": "about the products (ESRS sub-sub-topic) refers to the transparent and truthful product information enabling informed choices."
    },
    {
      "id": "S4-foe",
      "title": "Freedom of expression",
      "description": "for customers and users (ESRS sub-sub-topic) refers to respecting the freedom of expression of end-users while also managing harmful content."
    },
    {
      "id": "S4-has",
      "title": "Health and safety",
      "description": "of consumers and users (ESRS sub-sub-topic) refers to preventing physical or psychological harm from products or services throughout their lifecycle."
    },
    {
      "id": "S4-ndi",
      "title": "Non-discrimination",
      "description": "of consumers and users (ESRS sub-sub-topic) refers to the equal treatment of end-users regardless of characteristics such as gender, disability, nationality, age, or religion."
    },
    {
      "id": "S4-poc",
      "title": "Protection of children",
      "description": "(ESRS sub-sub-topic) refers to safeguarding child end-users from harm, abuse, or inappropriate content."
    },
    {
      "id": "S4-prv",
      "title": "Privacy",
      "description": "of consumers and users (ESRS sub-sub-topic) refers to the responsible collection, use, and protection of personal data of end-users."
    },
    {
      "id": "S4-rmp",
      "title": "Responsible marketing practices",
      "description": "(ESRS sub-sub-topic) refers to the truthful, fair, and non-manipulative advertising protecting vulnerable users."
    },
    {
      "id": "S4-sop",
      "title": "Security of a person",
      "description": "(ESRS sub-sub-topic) refers to ensuring products and services do not endanger the physical or psychological safety of end-users."
    },
    {
      "id": "U-H3",
      "title": "Nutrition",
      "description": "(entity-specific topic) refers to the nutritional quality, availability, and access to food. "
    },
    {
      "id": "U-H4",
      "title": "Relationships",
      "description": "(entity-specific topic) refers to social interactions, violence and aggression, communities, and emotional intelligence. "
    },
    {
      "id": "U-H5",
      "title": "Meaning & joy",
      "description": "(entity-specific topic) refers to meaning, life satisfaction, purpose, joy, pleasure, and enjoyment."
    },
    {
      "id": "U-K1",
      "title": "Scarce human capital",
      "description": "(entity-specific topic) refers to the opportunity cost of employing people with scarce skills and capabilities, treating it as a resource utilized by a company, similar to environmental resources. "
    },
    {
      "id": "U-K2",
      "title": "Knowledge infrastructure",
      "description": "(entity-specific topic) refers to enabling the creation, distribution, management, and utilization of data, information and knowledge. "
    },
    {
      "id": "U-K3",
      "title": "Creating knowledge",
      "description": "(entity-specific topic) refers to the creation of informational content, processing of data to information and insights, collection of data, creation of art, and innovations. "
    },
    {
      "id": "U-K4",
      "title": "Distributing knowledge",
      "description": "(entity-specific topic) refers to the distribution of knowledge via traditional and digital channels, transmission of data, knowledge distribution through education, distribution of misinformation and spam content. "
    },
    {
      "id": "U-S1",
      "title": "Taxes",
      "description": "(entity-specific topic) refers to paying corporate income taxes, value-added taxes (VAT), personal income taxes related to salaries, and other taxes on goods and services. "
    },
    {
      "id": "U-S2",
      "title": "Jobs",
      "description": "(entity-specific topic) refers to employing people either directly or indirectly and thereby enabling individuals to achieve financial autonomy and a sense of belonging and identity within society."
    },
    {
      "id": "U-S3",
      "title": "Societal infrastructure",
      "description": "(entity-specific topic) refers to the contributions to the built environment, energy, transportation, physical security, social care, finance, water and sanitation, or industrial infrastructure. "
    },
    {
      "id": "U-S5",
      "title": "Societal stability",
      "description": "(entity-specific topic) refers to the contribution to social inclusion, cohesion and polarization."
    }
  ]